import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';
import { SG_ERROR_TYPE_1 } from 'Store/constants/sportTypes';

const PlayFailure = props => {
  const { playCouponError } = props;
  const coupon_back_button_text = EnvironmentManager.getMessageText({ key: 'coupon_back_button_text' }) || 'KUPONA DÖN';

  const buttonConfig = {
    primary: {
      label: SG_ERROR_TYPE_1.includes(`${playCouponError.domain}${playCouponError.code}`) ? coupon_back_button_text : 'KUPONLARIMA GİT',
      onClick: props.onPrimaryButtonClick
    }
  };

  const errDomainCode = `${playCouponError.domain}${playCouponError.code}`;

  const failureMessage
    = playCouponError && EnvironmentManager.getMessageText({ key: errDomainCode })
    || 'Sistemsel bir sorundan dolayı kuponun oynanamadı. Lütfen tekrar dene.';


  if (errDomainCode === 'iddaa-coupons-api35116' || errDomainCode === 'iddaa-coupons-api25116') { // oran değişimini kabul etmediği için alınan hata ise, betslipe yolla ayarlar menusunu aç
    buttonConfig.primary.label = EnvironmentManager.getMessageText({ key: 'button_betslip_settings' });
    buttonConfig.primary.onClick = props?.onSecondaryButtonClick;
  }

  const extraMessages = playCouponError?.extras?.extraMessages?.[0]?.eventName;

  return (
    <Message type="none" buttonConfig={ buttonConfig } >
      <p>{ failureMessage }</p>

      { extraMessages
        && <div className="play-failure-modal__extra-messages">
          <b>{ extraMessages }</b>
        </div>
      }

    </Message>
  );
};

PlayFailure.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  onSecondaryButtonClick: PropTypes.func,
  playCouponError: PropTypes.object
};

export default PlayFailure;
